'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactForm = require('react-form');

exports.default = _reactForm.Form;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9Gb3JtLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBIiwiZmlsZSI6IkZvcm0uanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBGb3JtIH0gZnJvbSAncmVhY3QtZm9ybSdcbmV4cG9ydCBkZWZhdWx0IEZvcm0iXX0=


//////////////////
// WEBPACK FOOTER
// ./node_modules/@geopagos/gp-forms/lib/Form.js
// module id = 228
// module chunks = 0